import Page404 from '../Pages/NotFound/Page404';
import TimeSheetPage from '../Pages/TimeSheet/TimeSheetPage';
import UserManagementPage from '../Pages/UserManagement/UserManagementPage';
import Project from '../Pages/Project/Project';
import AddProject from '../Components/Project/AddProject';
import AddUserPage from '../Pages/UserManagement/AddUserPage';
import Master from '../Pages/Master/Master';
import Module from '../Pages/Module/Module';
import { Department } from '../Pages/Departments/Department';
import { Designation } from '../Pages/Designations/Designation';
import UserRole from '../Components/UserRole/UserRoleComponent';
import Leave from '../Pages/Leave/Leave';
import AttendanceReport from '../Pages/Reports/AttendanceReport';
import EffortVarience from '../Pages/Reports/EffortVarience';
import AddUserType from '../Components/UserManagement/AddUserType';
import ViewProfile from '../Pages/ViewProfiles/ViewProfile';
import AddUserRole from '../Components/UserRole/AddUserRole';
import EmailComponent from '../Components/Email/EmailComponent';
import Settings from '../Pages/Settings/Settings';
import { LeaveMangment } from '../Pages/LeaveMangment/LeaveMangment';
import { UserTimesheet } from '../Components/TimeSheet/UsersTimeSheet/UserTimesheet';
import UserTimeSheetView from '../Components/TimeSheet/UsersTimeSheet/UserTimeSheetView';
import ViewProject from '../Components/Project/ViewProject';
import { LeaveManagementView } from '../Components/LeaveMangmentComponent/LeaveManagementView';
import CompetencyMatrix from '../Pages/Reports/CompetencyMatrix';
import SkillMatrix from '../Pages/Reports/SkillMatrix';
import SelfReview from '../Pages/EmployeesReview/SelfReview';
import UserRequests from '../Components/LeaveMangmentComponent/UserRequests';
import UserManagementView from '../Components/UserManagement/UserManagementView';
import NotificationHistory from '../Pages/Reports/NotificationHistory';
import DraftModule from '../Pages/DraftModule/DraftModule';
import ProjectTable from '../Components/Project/ProjectTable';
import ResetPassword from '../Components/Login/ResetPassword';
import DepartmentReport from '../Pages/Reports/DepartmentReport';
import Dashboard from '../Pages/Dashboard/Dashboard';
import UserReport from '../Components/Reports/DepartmentReport/UserReport';
import UserReportPage from '../Pages/Reports/UserReportPage';
import UserLog from '../Pages/UserLog/UserLog';
import ProjectTracking from '../Pages/Project/ProjectTracking/ProjectTracking';
import ProjectHistoryComp from '../Components/ProjectHistory/projectHistoryComponent';
import SurveyCategory from '../Pages/SurveyCategory/SurveyCategory';
import CreateSurveyQn from '../Components/Survey/CreateSurveyQn';
import QuestionBankComp from '../Components/QuestionBank/QuestionBankComp';
import AddQuestionBank from '../Components/QuestionBank/AddQuestionBank';
import SurveyDashboard from '../Components/Dashboard/SurveyDashboard';
import QuestionBank from '../Pages/Question Bank/QuestionBank';
import Survey from '../Pages/Survey/Survey';
import { SurveyReportComp } from '../Components/Reports/SurveyReport/SurveyReportComp';
import { SurveyBasedUsersComp } from '../Components/Reports/SurveyReport/SurveyBasedUsersComp';
import PreviewQuestionBank from '../Components/QuestionBank/PreviewQuestionBank';
import MysurveyQuestions from '../Components/MySurvey/MySurveyQuestions';
import ApproveQuestions from '../Components/Approvals/ApprovalsQuestions';
import MySurvey from '../Pages/MySurvey/MySurvey';
import Approvals from '../Pages/Approvals/Approvals';
import SurveyPeriod from '../Pages/SurveyPeriod/SurveyPeriod';
import EmployeesListPage from '../Pages/EmployeesReview/EmployeesList';
import EmployeesReview from '../Pages/EmployeesReview/EmployeesReview';
import Qualification from '../Pages/Qualification/Qualification';
import Trainings from '../Pages/Trainings/Trainings';
import CreateTrainings from '../Components/Trainings/CreateTrainings';
import TrainingsCalenderView from '../Components/Trainings/TrainingsCalendarView';
import TrainingList from '../Components/Trainings/TrainingsList';
import TrainingsOverView from '../Components/Trainings/TrainingsOverView';
import TrainingsAttendance from '../Components/Trainings/TrainingsAttendance';
import TrainingsFeedback from '../Components/Trainings/TrainingsFeedback';
import TrainingsReports from '../Components/Trainings/TrainingsReports';
import TrainingsReview from '../Components/Trainings/TrainingsReview';
import TrainingsView from '../Components/Trainings/TrainingsView';
import TraineeAttendance from '../Components/Trainings/TraineeAttendance';
import TraineeReview from '../Components/Trainings/TraineeReview';
import TraineeFeedback from '../Components/Trainings/TraineeFeedback';

export const routes = [
  //Dashboard
  {path: '/dashboard',component: <Dashboard />},
  {path: '/dashboard/surveydashboard',component: <Dashboard />},
  { path: '/survey_dashboard', component: <SurveyDashboard /> },
  //Login
  { path: '/reset_password/:emailId', component: <ResetPassword /> },
  //My Timesheet
  { path: '/timesheet', component: <TimeSheetPage /> },
  { path: '/user_timesheet', component: <UserTimesheet /> },
  { path: '/my_user_timesheet/:edit_id', component: <UserTimeSheetView /> },
  //Projects
  { path: '/projects', component: <Project /> },
  { path: '/projects/:view_type', component: <Project /> },
  { path: '/add_Project/:view_type', component: <AddProject /> },
  { path: '/add_Project/:view_type/:edit_id', component: <AddProject /> },
  { path: '/View_Project/:view_type/:edit_id/:editPermission',component: <ViewProject />,},
  { path: '/Project_Table', component: <ProjectTable /> },
  { path: '/module', component: <Module /> },
  { path: '/project_tracking', component: <ProjectTracking /> },
  {path: '/project_History/:edit_id',component: <ProjectHistoryComp />,},
  //Users
  { path: '/user', component: <UserManagementPage /> },
  { path: '/add_user', component: <AddUserPage /> },
  { path: '/add_user/:edit_id', component: <AddUserPage /> },
  { path: '/user_role', component: <UserRole /> },
  { path: '/add_user_Type', component: <AddUserType /> },
  { path: '/add_user_Role/:edit_id', component: <AddUserRole /> },
  { path: '/add_user_Role', component: <AddUserRole /> },
  //Masters
  { path: '/masters', component: <Master /> },
  { path: '/draft_module', component: <DraftModule /> },
  { path: '/department', component: <Department /> },
  { path: '/qualification', component: <Qualification /> },
  { path: '/designation', component: <Designation /> },
  { path: '/leaves', component: <Leave /> },
  { path: '/email_notification', component: <EmailComponent /> },
  //Survey
  { path: '/survey', component: <Survey /> },
  { path: '/survey/create', component: <CreateSurveyQn /> },
  { path: '/survey/edit/:id', component: <CreateSurveyQn /> },
  { path: '/survey/preview/:id', component: <CreateSurveyQn /> },
  { path: '/survey_category', component: <SurveyCategory /> },
  { path: '/survey_period', component: <SurveyPeriod /> },
  //Question Bank
  { path: '/question_bank', component: <QuestionBank /> },
  { path: '/add-question', component: <AddQuestionBank /> },
  { path: '/add-question/:id/:categoryId', component: <AddQuestionBank /> }, 
  {path: '/edit-question/:id/:categoryId',component: <PreviewQuestionBank />,}, 
  {path: '/view-question/:id/:categoryId',component: <PreviewQuestionBank />,},
  { path: '/titlebase/:id', component: <QuestionBankComp /> },
  //My survey
  { path: '/mysurvey', component: <MySurvey /> },
  { path: '/my-Survey/:id', component: <MysurveyQuestions /> },
  //Approvals
  { path: '/approvals', component: <Approvals /> },
  { path: '/aproved/:id', component: <ApproveQuestions /> },
  //Trainings
  { path: '/trainings', component: <Trainings /> },
  { path: '/trainings_list', component: <TrainingList /> },
  { path: '/trainings_calendar', component: <TrainingsCalenderView /> },
  { path: '/create_trainings', component: <CreateTrainings /> },
  { path: '/create_trainings/:edit_id', component: <CreateTrainings /> },
  { path: '/trainings_view', component: <TrainingsView /> },
  { path: '/trainings_overview', component: <TrainingsOverView /> },
  { path: '/trainings_attendance', component: <TrainingsAttendance /> },
  { path: '/trainings_feedback', component: <TrainingsFeedback /> },
  { path: '/trainings_review', component: <TrainingsReview /> },
  { path: '/trainings_reports', component: <TrainingsReports /> },
  { path: '/trainee_attendance', component: <TraineeAttendance /> },
  { path: '/trainee_feedback', component: <TraineeFeedback /> },
  { path: '/trainee_review', component: <TraineeReview /> },
  //Reports
  { path: '/attendance_report', component: <AttendanceReport /> },
  { path: '/effort_variance', component: <EffortVarience /> },
  { path: '/department_report', component: <DepartmentReport /> },
  { path: '/user_report', component: <UserReportPage /> },
  { path: '/survey_report', component: <SurveyReportComp /> },
  {path: '/survey_report/:surveyId/base_users',component: <SurveyBasedUsersComp />,},
  { path: '/Competency_Matrix', component: <CompetencyMatrix /> },
  { path: '/skill_matrix', component: <SkillMatrix /> },
  {path: '/department_view/:department_id/:department_name',component: <UserReport />,},
  { path: '/notification', component: <NotificationHistory /> },
  //Settings
  { path: '/settings', component: <Settings /> },
  //User Logs
  { path: '/user_log', component: <UserLog /> },
  //Employees Review
  { path: '/employees_review', component: <EmployeesListPage /> },
  { path: '/employees/:reviewId', component: <EmployeesReview /> },
  { path: '/self_review', component: <SelfReview /> },
  //Leaves - Permissions
  { path: '/my_requests', component: <LeaveMangment /> },
  { path: '/my_requests/view', component: <LeaveManagementView /> },
  {path: '/my_requests/view/:edit_id/:userType/:permission',component: <LeaveManagementView />,},
  { path: '/user_requests/view', component: <LeaveManagementView /> },
  {path: '/user_requests/view/:edit_id/:userType/:permission',component: <LeaveManagementView />,},
  { path: '/user_requests', component: <UserRequests /> },
  {path: '/user/view/:edit_id/:permission',component: <UserManagementView />,},
  { path: '/my_requests_permission', component: <LeaveMangment /> },
  { path: '/my_requests_permission/view', component: <LeaveManagementView /> },
  {path: '/my_requests_permission/view/:edit_id/:userType/:permission',component: <LeaveManagementView />,},
  { path: '/user_requests_permission', component: <UserRequests /> },
  {path: '/user_requests_permission/view',component: <LeaveManagementView />,},
  {path: '/user_requests_permission/view/:edit_id/:userType/:permission',component: <LeaveManagementView />,},
  //common-routes
  { path: '/View_Profile', component: <ViewProfile /> },
  //unknown path handler
  { path: '*', component: <Page404 /> },
];
